import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  /* Import Poppins font from Google Fonts */
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');

  /* CSS Reset */
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  /* Remove default margin */
  body,
  h1,
  h2,
  h3,
  h4,
  p,
  figure,
  blockquote,
  dl,
  dd {
    margin: 0;
  }

  /* Set core body defaults */
  body {
    min-height: 100vh;
    text-rendering: optimizeSpeed;
    line-height: 1.5;
    font-family: 'Poppins', sans-serif;
    background-color: #FFFFFF;
    color: #333333;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  /* Make images easier to work with */
  img,
  picture {
    max-width: 100%;
    display: block;
  }

  /* Inherit fonts for inputs and buttons */
  input,
  button,
  textarea,
  select {
    font: inherit;
  }

  /* Remove all animations and transitions for people that prefer not to see them */
  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }

  /* Custom scrollbar styles */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  /* Selection styles */
  ::selection {
    background-color: #CC1042;
    color: white;
  }

  /* Focus styles */
  :focus {
    outline: 2px solid #CC1042;
    outline-offset: 2px;
  }

  /* Remove focus outline for mouse users */
  :focus:not(:focus-visible) {
    outline: none;
  }

  /* Focus visible styles */
  :focus-visible {
    outline: 2px solid #CC1042;
    outline-offset: 2px;
  }

  /* Link styles */
  a {
    color: #CC1042;
    text-decoration: none;
    transition: color 0.2s ease;
  }

  a:hover {
    color: #990C32;
  }

  /* Table styles */
  table {
    border-collapse: collapse;
    width: 100%;
  }

  th, td {
    text-align: left;
    padding: 8px;
  }

  /* List styles */
  ul, ol {
    list-style-position: inside;
    padding-left: 0;
  }

  /* Button reset */
  button {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
  }

  /* Form element focus states */
  input:focus,
  textarea:focus,
  select:focus {
    outline: 2px solid #CC1042;
    outline-offset: 2px;
  }
`;

export default GlobalStyles;
